import { render, staticRenderFns } from "./recontentMug.vue?vue&type=template&id=381f2442&scoped=true&"
import script from "./recontentMug.vue?vue&type=script&lang=js&"
export * from "./recontentMug.vue?vue&type=script&lang=js&"
import style1 from "./recontentMug.vue?vue&type=style&index=1&id=381f2442&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f2442",
  null
  
)

export default component.exports